import C from '@/store/constants'

const contextPath = "/signatures";

export default {
  namespaced: true,
  state: {},
  actions: {
    getSignatureTemplates ({ dispatch }, tag) {
      const params = []
      if (tag) {
        params.push("tag=" + encodeURIComponent(tag));
      }
      let path = contextPath + "/templates";
      if (params.length > 0) {
        path = path + ("?" + params.join("&"));
      }
      return new Promise(function(resolve, reject) {
        return dispatch("API", C.service.SIGNATURE_SERVICE, { root: true })
          .then((api) => api.get(path))
          .then((response) => resolve(response.data))
          .catch((err) => reject(err));
      });
    },

    getSignatureTemplate ({ dispatch }, id) {
      return new Promise(function(resolve, reject) {
        return dispatch("API", C.service.SIGNATURE_SERVICE, { root: true })
          .then((api) =>
            api.get(contextPath + "/templates/" + encodeURIComponent(id))
          )
          .then((response) => resolve(response.data))
          .catch((err) => reject(err));
      });
    },

    saveSignatureTemplate ({ dispatch }, data) {
      return new Promise(function(resolve, reject) {
        return dispatch("API", C.service.SIGNATURE_SERVICE, { root: true })
          .then((api) => {
            if (data.id) {
              return api.put(
                contextPath + "/templates/" + encodeURIComponent(data.id),
                data
              );
            } else {
              return api.post(contextPath + "/templates", data);
            }
          })
          .then((response) => resolve(response.data))
          .catch((err) => reject(err));
      });
    },

    deleteSignatureTemplate ({ dispatch }, id) {
      return new Promise(function(resolve, reject) {
        return dispatch("API", C.service.SIGNATURE_SERVICE, { root: true })
          .then((api) =>
            api.delete(contextPath + "/templates/" + encodeURIComponent(id))
          )
          .then((response) => resolve(response.data))
          .catch((err) => reject(err));
      });
    },
  }
};
